module.exports = __webpack_public_path__ + "static/img/234.53ea5d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/201206/234.jpg
// module id = R5yA
// module chunks = 0